/*
  LA Scroll Carousel — generische Swipe/Scroll-Karussell-Logik.
  Wiederverwendet von hub-collections.liquid und collection-inspiration.liquid
  (Hub-Kontext) statt Duplikat-JS pro Section. CSS bleibt bewusst lokal pro
  Section (eigene Klassennamen) — nur dieses Verhalten wird geteilt.

  Erwartete Struktur pro Instanz:
  <div data-scroll-carousel>
    <div data-scroll-viewport>            (overflow-x:auto; scroll-snap-type:x mandatory)
      <div data-scroll-track>...Items, je scroll-snap-align:start...</div>
    </div>
    <button data-scroll-prev>...</button>  (optional, irgendwo im Markup)
    <button data-scroll-next>...</button>
    <div data-scroll-bar><div data-scroll-thumb></div></div>  (optional)
  </div>
*/
(function () {
  function initCarousel(root) {
    var viewport = root.querySelector('[data-scroll-viewport]');
    var track = root.querySelector('[data-scroll-track]');
    var prevBtn = root.querySelector('[data-scroll-prev]');
    var nextBtn = root.querySelector('[data-scroll-next]');
    var thumb = root.querySelector('[data-scroll-thumb]');
    if (!viewport || !track) return;

    function update() {
      var maxScroll = track.scrollWidth - viewport.clientWidth;
      var atStart = viewport.scrollLeft <= 2;
      var atEnd = viewport.scrollLeft >= maxScroll - 2;
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = maxScroll <= 2 || atEnd;
      if (thumb) {
        if (maxScroll <= 2) {
          thumb.style.width = '100%';
          thumb.style.transform = 'translateX(0)';
        } else {
          var ratio = viewport.clientWidth / track.scrollWidth;
          var widthPct = Math.max(ratio * 100, 12);
          var travel = 100 - widthPct;
          var scrollRatio = viewport.scrollLeft / maxScroll;
          thumb.style.width = widthPct + '%';
          thumb.style.transform = 'translateX(' + (scrollRatio * travel / widthPct * 100) + '%)';
        }
      }
    }

    function step() {
      var firstItem = track.children[0];
      var itemWidth = firstItem ? firstItem.getBoundingClientRect().width : viewport.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      return (itemWidth + gap) * 2;
    }

    prevBtn && prevBtn.addEventListener('click', function () {
      viewport.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    nextBtn && nextBtn.addEventListener('click', function () {
      viewport.scrollBy({ left: step(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-scroll-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
